import styled from "styled-components"
import H2 from "../atoms/typography/H2"
import { Entry, RichTextField } from "../../graphql/contentful/types"
import { EntryComponentMap, renderRichTextField } from "../../utils/contentful/renderRichText"
import { ContentfulEntryTypeName, ENTRIES_CONTENTFUL } from "../contentful/entries"

export interface RichTextProps<T extends string> {
  rtf: RichTextField<Entry<T>>
  entries?: EntryComponentMap<T>
}

const RichTextStyle = styled.div`
  & > * {
    margin-bottom: 2rem;
  }
  ${H2} {
    margin-bottom: 1rem;
  }
`

const RichText = ({ rtf, entries = ENTRIES_CONTENTFUL }: RichTextProps<ContentfulEntryTypeName>) => {
  return <RichTextStyle>{renderRichTextField(rtf, entries)}</RichTextStyle>
}

export default RichText
